export const toCamelCase = (str: string) => {
  return str.toLowerCase().replace(/[-_/]+(.)?/g, (_match: string, group: string) => {
    return group ? group.toUpperCase() : ''
  })
}
